<template>
  <div class="item-container">
    <div class="item-title">
      <span class="i-title-text"
        >{{ navData[data.chartGroup] }}{{ typeData[type].name }}数据</span
      >
      <van-popover
        v-model="showPopover"
        trigger="click"
        :offset="[-8, 8]"
        placement="bottom-start"
      >
        <div class="tips">{{ typeData[type].tips }}</div>
        <template #reference>
          <span class="iconfont icon-help"></span>
        </template>
      </van-popover>
    </div>
    <div class="echart-container">
      <LineComponent
        v-show="index == curActive"
        v-for="(item, index) in data.dataList"
        :key="index"
        :data="item"
      />
    </div>
    <div class="block-container show-scroll-bar">
      <div class="block-scroll" v-for="(item, index) in blockData" :key="index">
        <BlockItem
          @click="bindClickBlock"
          v-for="(item1, index1) in item"
          :key="index1"
          :type="type"
          :active="data.dataList[curActive].key == item1.key"
          :data="item1"
        />
      </div>
    </div>
    <template v-if="data.summary">
      <div class="desc-title">数据说明</div>
      <div class="desc-container">
        <div class="time">{{ time() | filterTime }}数据分析:</div>
        <div class="data-desc">{{ data.summary }}</div>
      </div>
    </template>
  </div>
</template>
<script>
import BlockItem from './block.vue'
import LineComponent from './line.vue'
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  filters: {
    filterTime(str) {
      console.log(str)
      let time = new Date(str * 1000)
      let month = time.getMonth() + 1
      let day = time.getDate()
      return month + '月' + day + '日'
    }
  },
  inject: {
    time: { value: 'time', default: '' }
  },
  components: {
    BlockItem,
    LineComponent
  },
  computed: {
    blockData() {
      if (this.data.dataList) {
        if (this.data.dataList.length <= 4) {
          return [this.data.dataList]
        } else {
          let len = Math.ceil(this.data.dataList.length / 2)
          return [
            this.data.dataList.slice(0, len),
            this.data.dataList.slice(len)
          ]
        }
      } else {
        return []
      }
    }
  },
  data() {
    return {
      curActive: 0,
      showPopover: false,
      typeData: {
        day: {
          name: '日',
          tips: '取近7天数据（昨日及往前推6天）'
        },
        week: {
          name: '周',
          tips: '取近5周，每周累计数据，当前周取周一截止到昨日数据'
        },
        month: {
          name: '月',
          tips: '取近5月，每月累计数据，当前月取1号截止到昨日数据'
        }
      },
      navData: {
        appSummary: 'APP',
        convertSummary: '转化',
        followEatSummary: '跟吃',
        positionSummary: '金刚位（uv曝光点击率）'
      }
    }
  },
  methods: {
    bindClickBlock(item) {
      for (let i = 0; i < this.data.dataList.length; i++) {
        if (item.key == this.data.dataList[i].key) {
          this.curActive = i
          this.data.dataList[i].loaded = true
          break
        }
      }
      console.log(this.curActive)
    }
  }
}
</script>
<style lang="scss" scoped>
.tips {
  padding: 10px 16px;
}

.item-container {
  color: rgba(0, 0, 0, 0.8);
  padding: 20px 10px;

  .item-title {
    display: flex;
    align-items: center;

    .i-title-text {
      margin-right: 6px;
      font-size: 14px;
      font-weight: 600;
    }
  }

  .echart-container {
    height: 300px;
    margin-bottom: 16px;
  }

  .block-container {
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
    .block-scroll {
      display: inline-flex;
      align-items: stretch;
    }
  }
  .block-container::-webkit-scrollbar {
    width: 6px;
    height: 4px;
    background-color: transparent;
  }
  .block-container::-webkit-scrollbar-thumb {
    background: #e1e1e1;
  }
  .desc-title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .desc-container {
    background-color: #fff;
    padding: 10px;
    border-radius: 8px;
    border: 1px solid #caccd1;

    .time {
      font-size: 12px;
      margin-bottom: 8px;
    }

    .data-desc {
      font-size: 14px;
      white-space: pre-wrap;
    }
  }
}
</style>
